// do I even need to explain this? :D
export default function getTomorrowDate() {
  const today = new Date()
  const tomorrow = new Date()

  tomorrow.setDate(today.getDate() + 1)

  return tomorrow
}
